const langConfig = require('../../config/lang');

const getPrefix = (value) => {
    const currLang = langConfig.langs.find((lang) => lang.value === value);
    return currLang ? currLang.prefix : '';
};

const isDefaultLang = (value) => value === langConfig.defaultLang;

const getPrefixExceptDefault = (value) =>
    !isDefaultLang(value) ? getPrefix(value) : '';

module.exports = {
    getPrefix,
    isDefaultLang,
    getPrefixExceptDefault
}